import { HttpInterceptorFn } from '@angular/common/http';
import {environment} from "../environments/environment";

export const cookieInterceptor: HttpInterceptorFn = (req, next) => {
  if(req.url.match(/^https:\/\/[a-zA-Z0-9.]+(:[0-9]+)?\/json/)) return next(req);
  const cloned = req.clone({
    withCredentials: true
  })
  return next(cloned);
};
